// common function to apply one transition rule
export function transition(
  elem: HTMLElement,
  styleProps: Record<string, string>
) {
  return new Promise((resolve, _) => {
    function handleTransitionEnd() {
      console.log('Transition Ended...');
      resolve(elem);
    }
    elem.addEventListener('transitionend', handleTransitionEnd, {
      once: true,
    });
    Object.entries(styleProps).forEach(([prop, value]) => {
      elem.style.setProperty(prop, value);
    });
  });
}

// common function to apply animations to an element.
export function animate(elem: HTMLElement, animation: string) {
  return new Promise((resolve, _) => {
    function handleAnimationEnd() {
      console.log('animation ended...');
      resolve(elem);
    }
    elem.addEventListener('animationend', handleAnimationEnd, { once: true });
    elem.classList.add(animation);
  });
}
